import { ADModalBody, ADModalFooter, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal"
import { GlassInputControl, GlassInputGroup, GlassInputGroupEscape, GlassInputGroupTitle, GlassTextInputTransformer } from "./GlassInput"
import { GlassButton } from "./GlassButtons"
import { Localization } from "@viamap/viamap2-common"
import { companyLogoSource } from "src/managers/companyLogo"
import { useState } from "react"
import { closeWindow, ManagedWindow } from "src/WindowManager/WindowState"
import { useWindowContext } from "src/WindowManager/useWindowContext"

type valueType = {
   "url": string,
   "desiredHeight": number,
   "offsetX": number,
   "offsetY": number
}

export function PlotLogoEditor(props:
   {
      managedWindow: ManagedWindow
      value?: valueType
      onChange(value: valueType): void
      default: valueType
      disabled?: boolean
   }): JSX.Element | null {

   const { dispatch: windowDispatch } = useWindowContext()
   const [lValue, setLValue] = useState<valueType>(props.value || props.default);
   const companyLogo = companyLogoSource();
   const previewSrc = companyLogo || (lValue.url.startsWith("http") ? lValue.url : "/Mapit/MapitLogoTissegul.svg");

   return (
      <AdvancedDragModal window={props.managedWindow} title={"Plot Logo Editor"}
         onClose={() => windowDispatch(closeWindow(props.managedWindow.id))}
      >
         <ADModalBody>
            <GlassInputGroup>
               <GlassInputGroupEscape>
                  <p style={{ margin: "0 0 8px" }}>
                     {Localization.getText("The logo file is set as the company logo in organization settings.")}
                  </p>
               </GlassInputGroupEscape>
               <GlassTextInputTransformer label={Localization.getText("Desired height")}>
                  <GlassInputControl>
                     <input
                        type="range"
                        value={lValue.desiredHeight || 0}
                        onChange={(e) => setLValue({ ...lValue, desiredHeight: Number(e.target.value) || 0, })}
                        disabled={props.disabled}
                        min={10 * 8}
                        max={50 * 8}
                     /><span>{Math.round((lValue.desiredHeight || 0) / 8)}mm</span>
                  </GlassInputControl>
               </GlassTextInputTransformer>
               <GlassTextInputTransformer label={Localization.getText("Offset X")}>
                  <GlassInputControl>
                     <input
                        type="range"
                        value={lValue.offsetX || 0}
                        onChange={(e) => setLValue({ ...lValue, offsetX: Number(e.target.value) || 0 })}
                        disabled={props.disabled}
                        min={-20 * 8}
                        max={20 * 8}
                     />
                     <span>{Math.round((lValue.offsetX || 0) / 8)}mm</span>
                  </GlassInputControl>
               </GlassTextInputTransformer>
               <GlassTextInputTransformer label={Localization.getText("Offset Y")}>
                  <GlassInputControl>
                     <input
                        type="range"
                        value={lValue.offsetY || 0}
                        min={-20 * 8}
                        max={20 * 8}
                        onChange={(e) => setLValue({ ...lValue, offsetY: Number(e.target.value) || 0 })}
                        disabled={props.disabled}
                     />
                     <span>{Math.round((lValue.offsetY || 0) / 8)}mm</span>
                  </GlassInputControl>
               </GlassTextInputTransformer>
               <GlassInputGroupTitle>{Localization.getText("Preview")}</GlassInputGroupTitle>
               <GlassInputGroupEscape>
                  <div style={{
                     background: "linear-gradient(-45deg, #f5f5f5, #eee0)", position: "relative", width: "80%", height: "120px", margin: "0 auto", padding: "10px",
                     borderRight: " 2px solid #ccc", borderBottom: "2px solid #ccc"
                  }}>
                     <img style={{
                        position: "absolute",
                        right: (lValue.offsetX || 0) / 8 + "mm",
                        bottom: (lValue.offsetY || 0) / 8 + "mm",
                        height: (lValue.desiredHeight || 0) / 8 + "mm"
                     }}
                        src={previewSrc} alt="Logo Preview" />
                  </div>
               </GlassInputGroupEscape>
            </GlassInputGroup>
         </ADModalBody>
         <ADModalFooter>
            <GlassButton onClick={() => windowDispatch(closeWindow(props.managedWindow.id))} >{Localization.getText("Cancel")}</GlassButton>
            <GlassButton onClick={() => { props.onChange(lValue); windowDispatch(closeWindow(props.managedWindow.id)) }} >{Localization.getText("Save")}</GlassButton>
         </ADModalFooter>
      </AdvancedDragModal>
   );
}